<template>
  <div class="privacyPolicy">
    <div class="section is-medium">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-one-quarter">
            <h1 class="deneme">GİZLİLİK POLİTİKASI
            </h1>
          </div>
          <div class="column tile is-parent is-vertical is-6">
            <span class="">
              <ul>
                <small>28 Ağustos 2017</small>
                <p>İşbu politika (“Politika”) www.sarikayasahin.com adresli web sitesinde (“Web Sitesi”) uygulanan gizlilik politikalarını düzenlemektedir. Web Sitesi’ne girerek, Politika’yı kabul ve teyit etmektesiniz.</p><br>
                <li>
                  <strong>Hangi bilgileri toplamaktayız?</strong>
                </li>
                <li>Web Sitesi aracılığıyla Web Sitesi’ni kullanma istatistikleriniz (kullandığınız internet tarayıcıları ve işletim sistemleri gibi) birlikte alan adlarını, IP adreslerini toplamaktayız. Bu veriler, Web Sitesi’nin daha verimli işletilmesi için kullanılmaktadır. Bu bilgileri, toplamış olduğumuz kişisel ve diğer bilgilerle birleştirebiliriz.
</li><br>

                <li>Aynı zamanda, bizimle iletişime geçerek paylaşmayı tercih ettiğiniz bilgileri de toplamaktayız. Lütfen sizi temsil ettiğimizi veya sizin adınıza hareket edeceğimizi size yazılı olarak bildirmeden gizli bilgilerinizi bizimle paylaşmayınız. Talebimiz olmaksızın müvekkilimiz olmayan kişi ve kuruluşlardan gelen e-postalar avukat-müvekkil ilişkisi oluşturmaz, gizli tutulmaz veya üçüncü kişilerle paylaşılabilir.</li><br>
              </ul>
              <ul>
                <li>
                <strong>Bilgilerinizi nasıl kullanıyoruz?</strong>
                </li>
                <li>
                  <li>Bilgilerinizi:</li><br>
                <li>i. taleplerinizi işlemek ya da yanıtlamak,</li><br>
                <li>ii. bilgilerinizi paylaşma amacınız doğrultusunda,</li><br>
                <li>iii. web Sitesi’nin içeriğini ve yön bulunabilirliğini geliştirmek,</li><br>
                <li>iv. yeni özellikler, özel etkinlikler ve hizmet teklifleri hakkında sizi bilgilendirmek için kullanabiliriz.</li><br>
              </ul>
              <ul>
                <li>
                <strong>Bilgilerinizi nasıl korumaktayız?</strong>
                </li><br>

                <li>Kişisel bilgilerinizin kaybolması, yanlış kullanılması ve değiştirilmesini önlemek amacıyla koruma girişimlerinde bulunur ve kişisel bilgilerinizi korumak için makul ölçüde idari, teknik ve fiziksel önlemler alırız.</li><br>
              </ul>
              <ul>
                <li>
                <strong>Bilgileriniz üçüncü kişilerle paylaşılabilir mi?</strong>
                <li/><br>

                <li>Uzmanlık alanlarımız dışında kalan ve Türk hukukuyla ilgisi olmayan bir konuda bizden hukuki yardım istemeniz durumunda, bilgileriniz Türkiye’deki veya Amerikan Birleşik Devletleri de dâhil olmak üzere diğer ülkelerdeki iş ortaklarımızla paylaşılabilir.</li><br>
              </ul>
              <ul>
                <li>
                <strong>Politika’da yapılabilecek değişiklikleri nasıl uygularız?</strong>
                </li><br>

                <li>Politika’da zaman zaman değişiklikler yapabiliriz.  Politika’da yapılan değişiklikler, yukarıda belirtilmiş olan Politika’nın en son gözden geçirildiği veya önemli ölçüde değiştiği yürürlük tarihinden itibaren geçerlidir. Web Sitesi’ni sürekli kullanımınız Politika’daki değişikliklere onay verdiğinizi göstermektedir. Politika’da yapılan değişikliklere itiraz etmeniz halinde lütfen bizimle iletişime geçiniz veya Web Sitesi’ni kullanmayı durdurunuz.</li><br>
              </ul>
              <ul>
                <li>
                <strong>İletişim</strong>
                </li><br>

                <li>Sarıkaya + Şahin</li><br>
                <li>E. info@sarikayasahin.com</li><br>
                <li>T. +90 533 424 85 00 - +90 533 425 85 00</li><br>
                <li>F. +90 212 385 00 05</li><br>
              </ul>
            </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'privacyPolicy',
    data() {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .privacyPolicy p {
    font-size: 1.5rem;
    text-align: justify;
  }

  #app {
    background: #606c96;
  }

  .privacyPolicy h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .privacyPolicy h1 {
    position: relative;
    color: #504f50;
    font-family: 'SEC', sans-serif;
  }

  .privacyPolicy h3 {
    position: relative;
    color: #504f50;
    font-size: 30px;
  }

  strong {
    font-size: 1.2rem;
    font-weight: 900;
    display: inline-block;
    padding-bottom: 20px;
  }

  .privacyPolicy ul li {
    text-align: justify;
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// gizlilik.vue?11e3658f